/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LegalAcceptanceRequest } from '@localstack/types';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LegalService {
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static recordLegalAcceptance(requestBody?: LegalAcceptanceRequest): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/legal/acceptance',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
